import { createDraftSafeSelector } from '@reduxjs/toolkit'

const selectJob = (state) => state.jobs

const jobselector = createDraftSafeSelector(selectJob, (job) => job)

export default jobselector
